import { getAllLookupItems } from 'api/lookuplistitemApi';

export const GET_LOOKUP_ITEMS = 'GET_LOOKUP_ITEMS';
export const SAVE_LOOKUP_ITEMS = 'SAVE_LOOKUP_ITEMS';

export const saveLookupItem = (data) => {
  return (dispatch) => dispatch({ type: SAVE_LOOKUP_ITEMS, payload: data });
};

export const getLookupItem = () => async (dispatch) => {
  const results = await getAllLookupItems();

  if (results.success) {
    dispatch({ type: SAVE_LOOKUP_ITEMS, payload: results.data });
  }

  return;
};



// WEBPACK FOOTER //
// ./src/@redux/actions/lookupitemsAction.js